import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import type { StateSnapshot, TableVirtuosoHandle, VirtuosoHandle } from 'react-virtuoso';
import { useIsReturningFromChildRoute } from '../../../../../hooks/useIsReturningFromChildRoute';

type VirtuosoRefHandle = VirtuosoHandle | TableVirtuosoHandle;

let storedSnapshot: { route: string; state: StateSnapshot } | null = null;

export const useVirtuosoSnapshot = ({ enableScrollRestore }: { enableScrollRestore: boolean }) => {
  const virtuosoRef = useRef<VirtuosoRefHandle | null>(null);
  const history = useHistory();
  const { pathname, search } = useLocation();
  const isReturningFromChildRoute = useIsReturningFromChildRoute();
  const route = `${pathname}${search}`;
  const routeRef = useRef(route);

  useEffect(() => {
    routeRef.current = route;
  }, [route]);

  const restoreStateFrom =
    enableScrollRestore && isReturningFromChildRoute && storedSnapshot?.route === route
      ? storedSnapshot.state
      : undefined;

  useEffect(() => {
    if (!enableScrollRestore) {
      return;
    }
    const unlisten = history.listen((nextLocation) => {
      if (nextLocation.pathname === pathname) {
        return;
      }
      virtuosoRef.current?.getState((state) => {
        storedSnapshot = { route: routeRef.current, state };
      });
    });
    return unlisten;
  }, [history, pathname, enableScrollRestore]);

  return { virtuosoRef, restoreStateFrom };
};
